
import React, { Component } from 'react';
import PracticeListRoot from './PracticeListRoot'
import { Popconfirm, message } from 'antd';
import DisplayNumber from './containers/DisplayNumber'
import { Link, Route, Switch, BrowserRouter as Router } from "react-router-dom"
import { Image, Layout, Menu, Breadcrumb, Col, Row ,Divider, Tooltip} from 'antd';
import { Input, Card, Button, Modal,  Progress, Table, Tag, Space } from 'antd';
import { Typography, PageHeader } from 'antd';
import axios from 'axios'
import { Document, Page } from 'react-pdf';
import {store} from './store'
import { resolveFileUrl } from './utils/resolveFileUrl'

const { TextArea } = Input;
const { Title } = Typography;
const { Header, Content, Footer } = Layout;
const { Column, ColumnGroup } = Table;

export default class PortfolioDetailPage extends Component{
  state = {
    modalVisible: false,
    numPages: null,
    pageNumber: 1,
    data: {
      record_image_urls:[]
    },
    username: '',
    portfolio:{},
    reject_comment:'',
    modal_comment: ''
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ ...this.state, numPages });
  }

  componentDidMount() {
    let portfolio_id = this.props.match.params.portfolio_id
    let req_data = { portfolio_id: portfolio_id }
    axios('/record/portfolio_detail', {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
      data: req_data
    }).then( res => {
      let portfolio = res.data.portfolio
      this.setState({ ...this.state, portfolio })
    });
  }

  deletePortfolio() {
    let portfolio_id = this.props.match.params.portfolio_id
    let req_data = { portfolio_id: portfolio_id }
    axios('/record/delete_portfolio', {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
      data: req_data
    }).then( res => {
      window.history.back()
    });
  }

  acceptPortfolio(portfolio_id, comment=null) {
    let req_data = { portfolio_id: portfolio_id, comment: comment }
    axios('/record/accept_portfolio', {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
      data: req_data
    }).then( res => {
      window.history.back()
    });
  }

  rejectPortfolio(portfolio_id, reject_comment) {
    let req_data = { portfolio_id: portfolio_id, reject_comment: reject_comment }
    axios('/record/reject_portfolio', {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
      data: req_data
    }).then( res => {
      window.history.back()
    });
  }

  rejectChange = e => {
    this.setState({ ...this.state, reject_comment: e.target.value })
  }

  getTag() {
    const listType_to_status = {
      'waiting': '승인대기',
      'rejected': '반려',
      'done': '승인완료'
    }
    let status_kr = listType_to_status[this.state.portfolio.status]
    let color
    if (status_kr === '반려') { color = 'volcano'; }
    else if (status_kr == '승인완료') { color = 'blue' }
    else if (status_kr == '승인대기') { color = 'gray' }
    return (
      <>
      <Tag color={color} key={this.state.portfolio.status}>{status_kr}</Tag>
      {this.state.portfolio.professor_comment_required ?
      <Tag color='blue' key={this.state.portfolio.professor_comment_required}>지도교수 코멘트 요청됨</Tag>
      : '' }
      </>
    );
  }

  openPrompt=() => {
    this.setState({...this.state, modalVisible:true})
  }

  changeComment = (e) => {
    this.setState({...this.state, modalComment: e.target.value });
  }

  acceptComment = () => {
    this.setState({...this.state, modalVisible:false})
  }

  getPdfUrl() {
    if (!this.state.portfolio || !this.state.portfolio.pdf_url) return '';
    return resolveFileUrl(this.state.portfolio.pdf_url);
  }

  render () {
    const { pageNumber, numPages} = this.state;

      return (
      <>
        <Modal
          title="지도교수 코멘트 입력"
          style={{ top: 20 }}
          visible={this.state.modalVisible}
          onOk={() => this.acceptPortfolio(this.props.match.params.portfolio_id , this.state.modalComment)}
          onCancel={() => this.setState({...this.state, modalVisible:false})}
        >
          <h3>지도학생이 지도교수 코멘트를 요청하였습니다</h3>
          <h3>입력된 코멘트는 지도학생의 포트폴리오 양식에 기입됩니다</h3>
          <TextArea value={this.state.modalComment} onChange={this.changeComment} placeholder='지도학생의 포트폴리오에 입력된 지도교수 코멘트를 입력해주세요'></TextArea>
        </Modal>
        <PageHeader
        className="site-page-header"
        onBack={() => window.history.back() }
        title='신청된 포트폴리오'
        subTitle={this.getTag()}
        extra={
              [<Tooltip title={store.getState().session.role=='professor'? '지도학생은 지도교수가 승인하기 전까지는 PDF를 다운받을 수 없습니다': this.state.portfolio.status!='승인완료'? '지도교수의 승인을 받은 뒤 다운로드할 수 있습니다':'포트폴리오가 승인되어 다운로드할 수 있습니다'}><Button key="1" type='primary' onClick={() => window.open(this.getPdfUrl())} disabled={this.state.portfolio.status!='done' && store.getState().session.role!='professor'} > 다운로드</Button></Tooltip>,
             store.getState().session.role=='professor' ? (
             <>
             {this.state.portfolio.status=='done'?'':
             <>
              {this.state.portfolio.professor_comment_required?
              <Button key="2" type='primary'  onClick={this.openPrompt} >승인</Button>
              :
              <Popconfirm
                placement="bottomRight"
                title={'신청된 포트폴리오를 승인하시겠습니까? '}
                onConfirm={() => this.acceptPortfolio(this.props.match.params.portfolio_id)}
                okText="승인"
                cancelText="취소"
              >
                <Button key="2" type='primary'  >승인</Button>,
              </Popconfirm>
              }
              <Popconfirm
                placement="bottomRight"
                title={<Input placeholder='반려사유 입력' onChange={this.rejectChange}></Input>}
                onConfirm={() => this.rejectPortfolio(this.props.match.params.portfolio_id, this.state.reject_comment)}
                okText="반려"
                cancelText="취소"
              >
                <Button key="2" type='dashed' danger>반려</Button>,
              </Popconfirm>
              </>
             }
            </>
            ):this.state.portfolio.status=='done'?'':(<Popconfirm
              placement="bottomRight"
              title={'신청된 포트폴리오를 취소하시겠습니까? '}
              onConfirm={() => this.deletePortfolio(this.props.match.params.portfolio_id)}
              okText="예"
              cancelText="아니오"
            >
              <Button key="2" type='dashed' danger>취소</Button>,
            </Popconfirm>)
            ]
        }
        />
      <div style={{textAlign:'center'}}>
        <Row>
          <Col span={16} offset={7}>
            <Document
              file={this.getPdfUrl()}
              onLoadSuccess={this.onDocumentLoadSuccess}>
              <Page pageNumber={pageNumber} />
            </Document>
          </Col>
        </Row>
        <p>
         <Button onClick={() => this.state.pageNumber > 1 ?
          	this.setState({...this.state, numPages : this.state.numPages,
            	pageNumber : this.state.pageNumber-1}) : null}
          > {'<'} </Button>

         <Tag>Page {pageNumber} of {numPages}</Tag>

         <Button onClick={() => this.state.pageNumber < numPages ?
         	this.setState({...this.state, numPages : this.state.numPages,
            	pageNumber : this.state.pageNumber+1}) : null}
          > {'>'} </Button>
        </p>
      </div>

        <Divider orientation='left'>
        </Divider>

      </>
      )
  };
};
